/**
 * IndoGhibliWedding — Studio Ghibli inspired anime digital wedding invitation.
 *
 * Registered under id 'exp-wedding-indo-ghibli-v1' so that:
 *   1. PublicInvitation.tsx routes here via registry.has(templateId).
 *   2. TemplateRenderer renders it by ID.
 *   3. StepTemplate & DraftPreviewModal can preview it via live SceneExperienceRenderer.
 */

import React from 'react';
import { SceneExperienceRenderer } from '@/src/modules/experiences/scene/SceneExperienceRenderer';
import { resolveExperienceManifest } from '@/src/modules/pages/ExperiencePreview';
import { registry } from '../registry';
import type { InvitationData, TemplateMetadata } from '../types';

export const META: TemplateMetadata = {
  id: 'exp-wedding-indo-ghibli-v1',
  name: 'Indo-Ghibli Anime Wedding',
  occasionType: 'WEDDING',
  description:
    'Hand-painted Studio Ghibli gouache anime wedding experience with golden hour palace balcony, lush gardens, and watercolor aesthetics.',
  isPremium: true,
  tags: [
    'cinematic',
    'wedding',
    'ghibli',
    'anime',
    'miyazaki',
    'watercolor',
    'handpainted',
    'premium',
    'scroll-experience',
    'ai-native',
  ],
  colorScheme: { primary: '#F59E0B', accent: '#FDE68A', bg: '#0F0A18' },
};

export function IndoGhibliWedding({ data, preview }: { data: InvitationData; preview?: boolean }) {
  const manifest =
    (data as any)?.sceneManifest ||
    resolveExperienceManifest('exp-wedding-indo-ghibli-v1', data);
  return <SceneExperienceRenderer manifest={manifest} preview={preview} />;
}

registry.register({ metadata: META, component: IndoGhibliWedding });
